import { WeeklyRatingPresenter } from '@/presentation/presenters/dashboard/weeklyRatingPresenter'
import { WeeklyRatingViewModel } from '@/presentation/viewmodels/dashboard/weeklyRatingViewModel'

export function useWeeklyRatingPresenter(
  presenter: WeeklyRatingPresenter = new WeeklyRatingPresenter(new WeeklyRatingViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    userWeeklyRatingList: presenter.userWeeklyRatingList,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    hasData: presenter.hasData,
    initChart: presenter.initChart.bind(presenter),
    addUserWeeklyRating: presenter.addUserWeeklyRating.bind(presenter),
    removeUserWeeklyRating: presenter.removeUserWeeklyRating.bind(presenter),
    removeTargetUsers: presenter.removeTargetUsers.bind(presenter)
  }
}
